module.exports = __webpack_public_path__ + "img/snake.9bbb0571.svg";